import { HUImageDtoSchema } from "@modules/dtos/imageDto"
import { z } from "zod"

export enum CategoryProgramVisibility {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
  MEMBERS = "MEMBERS",
  COACH_MEMBERS = "COACH_MEMBERS",
}

export const CategoryProgramDtoSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    description: z.string(),
    color: z.string(),
    visibility: z.enum(CategoryProgramVisibility),
    defaultHideSessionContent: z.boolean(),
    archived: z.boolean(),
    subscriberSlotVisibility: z.boolean(),
    image: HUImageDtoSchema.nullable(),
    restrictions: z.array(z.string()),
  })
  .meta({ id: "CategoryProgramDtoSchema" })

export type CategoryProgramDto = z.infer<typeof CategoryProgramDtoSchema>

export const CategoryProgramBodyInputDtoSchema = z
  .object({
    name: z.string(),
    description: z.string(),
    imageKey: z.string().nullable(),
    color: z.string(),
    visibility: z.enum(CategoryProgramVisibility),
    defaultHideSessionContent: z.boolean(),
    subscriberSlotVisibility: z.boolean(),
    restrictions: z.array(z.string()).nullable(),
  })
  .meta({ id: "CategoryProgramBodyInputDtoSchema" })

export type CategoryProgramBodyInputDto = z.infer<typeof CategoryProgramBodyInputDtoSchema>

export const CategorySlotDefaultParticipationDtoSchema = z
  .object({
    limitStart: z.number().nullable(),
    limitEnd: z.number().nullable(),
    limitCancel: z.number().nullable(),
  })
  .meta({ id: "CategorySlotDefaultParticipationDtoSchema" })

export type CategorySlotDefaultParticipationDto = z.infer<typeof CategorySlotDefaultParticipationDtoSchema>

export const CategorySlotDefaultValueDtoSchema = z
  .object({
    id: z.string(),
    programId: z.string(),
    duration: z.number().nullable(),
    participantLimit: z.number().nullable(),
    location: z.string().nullable(),
    participation: CategorySlotDefaultParticipationDtoSchema.nullable(),
    trialsAccepted: z.boolean().nullable(),
  })
  .meta({ id: "CategorySlotDefaultValueDtoSchema" })

export type CategorySlotDefaultValueDto = z.infer<typeof CategorySlotDefaultValueDtoSchema>

export type CategorySlotDefaultInputDto = Omit<CategorySlotDefaultValueDto, "id" | "programId">
